export enum ProcedureTestQuestionShowType {
  All = 'all',

  Random = 'random',
}